import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "antd";
import { useAuth } from "../../../context/AuthContext";
import useSet from "../../../hooks/common/useSet";
import { API_WALLET_DEPOSIT } from "../../../utils/apis";
import styled from "styled-components";
import { Create } from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
import { useToasts } from "../../../hooks/common/useToasts";

interface FormState {
  customer_no?: string;
  customer_mobile?: string;
  amount?: number;
}

const WalletDepositRequest = () => {
  const { error, uploadData, success, submitting, data } = useSet();
  const [form, setForm] = useState<FormState>({});
  const navigate = useNavigate();
  const { tranToken, userNumber } = useAuth();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value: string, fieldName: string) => {
    setForm((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    uploadData({
      api: API_WALLET_DEPOSIT,
      params: {
        ...form,
        tran_token: tranToken,
        user_no: userNumber,
      },
      method: "POST",
    });
  };

  // Navigate after successful transfer
  useEffect(() => {
    if (success) {
      navigate("/wallet-deposit/confirm", {
        state: {
          data: {
            data: data,
          },
        },
      });
    }
  }, [success, navigate, data, form]);

  useToasts({
    success,
    error,
    redirect: "reload",
    successMessage: "Operation Successfull",
  });

  return (
    <form onSubmit={onSubmit}>
      <Wrapper className="flexColumn gap20">
        <TitleWrapper className="flexNullCenter gap10 x100 whiteBg radius10">
          <Create fontSize="small" color="primary" />
          <p
            className="capitalize"
            style={{
              fontWeight: "bold",
              marginBottom: 0,
            }}
          >
            Deposit to your Wallet
          </p>
        </TitleWrapper>

        <div className="whiteBg radius10 p-3">
          <div className="capitalize bold pb-1 flexNullCenter mainColor">
            Wallet TopUp form
          </div>
          <FieldsWrapper>
            <div>
              <label htmlFor="customer_no">
                Mobile Money Number (Number to deduct from)
              </label>
              <PhoneInput
                country={"ug"}
                specialLabel={""}
                value={form.customer_no ?? ""}
                onChange={(value) => handlePhoneChange(value, "customer_no")}
                placeholder="Enter phone number"
                enableSearch={true}
                containerStyle={{ width: "100%" }}
                inputClass="phone-input-custom"
                dropdownStyle={{
                  borderRadius: "8px",
                  borderColor: "#ccc",
                  boxShadow:
                    "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
                }}
              />
            </div>
            <div>
              <label htmlFor="customer_mobile">Follow up Number</label>
              <PhoneInput
                country={"ug"}
                specialLabel={""}
                value={form.customer_mobile ?? ""}
                onChange={(value) =>
                  handlePhoneChange(value, "customer_mobile")
                }
                placeholder="Enter phone number"
                enableSearch={true}
                containerStyle={{ width: "100%" }}
                inputClass="phone-input-custom"
                dropdownStyle={{
                  borderRadius: "8px",
                  borderColor: "#ccc",
                  boxShadow:
                    "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
                }}
              />
            </div>

            <div>
              <label htmlFor="amount">Amount</label>
              <Input
                id="amount"
                name="amount"
                type="number"
                value={form.amount ?? ""}
                onChange={handleChange}
                required
              />
            </div>
          </FieldsWrapper>
        </div>
        <ButtonWrapper>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Continue
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </form>
  );
};

export default WalletDepositRequest;

const Wrapper = styled.div`
  padding: 0 20px 20px 20px;
  @media (max-width: 960px) {
  }
`;

const TitleWrapper = styled.div`
  padding: 10px;
  @media (max-width: 960px) {
  }
`;

const FieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  font-size: 12px;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
